import { Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { uniqueId } from 'lodash'
import React from 'react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

const StyledIcon = styled(Icon)({
  width: '1.5rem',
  height: '1.5rem',
  margin: '0 2px',
})

export default function TypePregnancyDiagnostics({ value }) {
  const statusIcon = {
    'reproduction.negative_pregnancy': (
      <StyledIcon name="close" color={Colors.feedback.danger.color} />
    ),
    'reproduction.pregnant': <StyledIcon name="mdi-check" color={Colors.feedback.success.color} />,
    'reproduction.inconclusive_pregnancy': <StyledIcon name="minus" />,
  }
  return (
    <div>
      {value?.map(val => (
        <Tooltip title={val.text} key={uniqueId(val.text)}>
          {statusIcon[val.status]}
        </Tooltip>
      ))}
    </div>
  )
}
